import { Sparkle } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export const PaymentAmountFields = ({ config, form, generated, onChange, onGenerate, saving }) => {
  const amountFields = [
    ["main_debt", "Main Debt (RM)", "mainDebtId", "mainDebtTestId"],
    ["interest_amount", "Interest (RM)", "interestId", "interestTestId"],
    ["penalty_amount", "Penalty (RM)", "penaltyId", "penaltyTestId"],
    [
      "referral_commission",
      "Referral Commission (RM)",
      "referralId",
      "referralTestId",
    ],
  ];

  return (
    <>
      {amountFields.map(([field, label, idKey, testIdKey]) => (
        <div key={field}>
          <Label htmlFor={config[idKey]}>{label}</Label>
          <Input
            id={config[idKey]}
            data-testid={config[testIdKey]}
            type="number"
            min="0"
            value={form[field]}
            onChange={(event) => onChange(field, event.target.value)}
          />
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        className="generate-remark-button"
        onClick={onGenerate}
        data-testid={config.generateTestId}
      >
        <Sparkle size={15} /> Generate Payment
      </Button>
      <div>
        <Label htmlFor={config.noteId}>Remark</Label>
        <Textarea
          id={config.noteId}
          data-testid={config.noteTestId}
          value={form.note}
          onChange={(event) => onChange("note", event.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={config.dateId}>Payment Date</Label>
        <Input
          id={config.dateId}
          data-testid={config.dateTestId}
          type="date"
          value={form.payment_date}
          onChange={(event) => onChange("payment_date", event.target.value)}
          required={config.requiresPaymentDate}
        />
      </div>
      <Button
        type="submit"
        disabled={saving || !generated}
        data-testid={config.submitTestId}
      >
        {saving ? "Saving…" : config.submitLabel}
      </Button>
    </>
  );
};